import React from 'react';

import styles from './styles.scss';
import {getClassNames} from "../../../services/stylingUtils";

export default class Label extends React.Component {

    _getClassNames() {
        return getClassNames(styles, this.props.className, {
            'label': true
        });
    }

    render() {
        const { text, required, ...allProps } = this.props;

        return (
            <label {...allProps} className={this._getClassNames()}>
                <span className={styles.labelText}>{ this.props.text }</span>
                { this.props.required && <span aria-hidden="true">&nbsp;*</span> }
                { this.props.children }
            </label>
        )
    }
}

Label.defaultProps = {
    required: false
};